import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";

import Routing from "./Routes/routers";
import NoInternet from "./Routes/NoInternet";
import NotificationBell from "./Views/Admin/Notifications/NotificationBell";

function App() {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [userRights, setUserRights] = useState(null);
  const [appConfig, setAppConfig] = useState({
    title: "Default App Title",
    logo: "/default-logo.svg",
    favicon: "/favicon.ico",
  });

  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};

  // 1. Monitor Online/Offline Status correctly using event listeners
  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // 2. Fetch User Rights from Session Storage
  useEffect(() => {
    const storedRights = sessionStorage.getItem("userRights");
    if (storedRights) {
      setUserRights(JSON.parse(storedRights));
    }
  }, []);

  // 3. Handle Domain Checking & Future-Ready Backend Config
  useEffect(() => {
 //   const currentDomain = window.location.hostname;
 // If on localhost, default to the production domain for testing
const currentDomain = window.location.hostname === "localhost" 
  ? "thekytslibrary.com" 
  : window.location.hostname;

    // Base Client-side fallback checks
    let determinedTitle = "The Kyts Library";
    let determinedFavicon = "/favicon.ico";

   // Change this line:
// if (currentDomain === "thekytslibrary.com" || (userData.token && userData.branch === "Kyts"))

// To this:
if (currentDomain.includes("thekytslibrary.com") || (userData.token && userData.branch === "Kyts")) {
  determinedTitle = "The Kyts Library";
  determinedFavicon = "/favicon_cutis.ico?v=2";
}

    // --- FUTURE READY BACKEND INTEGRATION ---
    // When your backend configuration API is ready, replace this mock function with your actual fetch call.
    const fetchBackendConfig = async () => {
      try {
        // Example: const response = await fetch('/api/app-config');
        // const data = await response.json();
        const data = null; // Mocking no backend data for now

        if (data && data.exists) {
          // If backend data exists, prioritize it completely
          setAppConfig({
            title: data.title || determinedTitle,
            logo: data.logo || "/default-logo.svg",
            favicon: data.favicon || determinedFavicon,
          });
        } else {
          // Fallback to domain/session storage rules
          setAppConfig((prev) => ({
            ...prev,
            title: determinedTitle,
            favicon: determinedFavicon,
          }));
        }
      } catch (error) {
        console.error("Failed to load backend branding configuration:", error);
      }
    };

    fetchBackendConfig();
  }, [userData.token, userData.branch]);

  // 4. Dynamically Apply Title and Favicon updates to the document DOM
  useEffect(() => {
    document.title = appConfig.title;

    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = appConfig.favicon;
    }
  }, [appConfig]);

  return (
    <BrowserRouter>
      {!online && <NoInternet />}
      {online && (
        <>
          {userData && userData.rights === "Admin" && (
            <NotificationBell userData={userData} />
          )}
          {/* Pro-tip: If you need the branding logo inside components, you can pass appConfig.logo down as a prop here */}
          <Routing userRights={userRights} setUserRights={setUserRights} appConfig={appConfig} />
        </>
      )}
    </BrowserRouter>
  );
}

export default App;